const devConfig = {
	apiKey: "AIzaSyD9tnehqQYxNmjsL98yl3a-b8ym3vIisRg",
	authDomain: "sbf-dev-79b77.firebaseapp.com",
	databaseURL: "https://sbf-dev-79b77.firebaseio.com",
	projectId: "sbf-dev-79b77",
	storageBucket: "sbf-dev-79b77.appspot.com",
	messagingSenderId: "462775426373"
};

const stagingConfig = {
	apiKey: "AIzaSyDxH5iUtGzD2xAiPwKb4D4W9j6B5nibfh0",
	authDomain: "sbf-dev-2.firebaseapp.com",
	databaseURL: "https://sbf-dev-2.firebaseio.com",
	projectId: "sbf-dev-2",
	storageBucket: "sbf-dev-2.appspot.com",
	messagingSenderId: "619109431163"
};
// TODO: Update
const productionConfig = stagingConfig;

export const getConfig = (override?: "staging") => {
	let config = devConfig;
	if (process.env.NODE_ENV === "production" || override === "staging") {
		console.log("Detected Production!");
		console.log("For now, using Staging Config");
		return productionConfig;
	}

	if (process.env.IS_CI === "TRUE") {
		console.log("CI Environment detected!");
		console.log("Using Development Configuration");
		return devConfig;
	}
	console.log("Couldn't determine current environment");
	console.log("Defaulting to Development");
	return devConfig;
};



// WEBPACK FOOTER //
// ./src/firebase/configs.ts